"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as i, forwardRef as l } from "react";
import { useSvgIcon as c } from "../useSvgIcon.js";
const m = i(
  l((e, r) => {
    const { monochrome: s, ...n } = e, t = c({
      ...n,
      ref: r
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ o(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.39007 7C2.62236 7 2 7.62236 2 8.39007V23.8794C2 24.6471 2.62236 25.2695 3.39007 25.2695H28.6099C29.3776 25.2695 30 24.6471 30 23.8794V8.39007C30 7.62236 29.3776 7 28.6099 7H3.39007ZM4.08511 9.08511V11.5674L15.9007 17.4255H16.0993L27.9149 11.5674V9.08511H4.08511Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
m.displayName = "IconYahoo";
export {
  m as IconYahoo
};
